export enum AutopilotActionType {
  create = 'create',
  merge = 'merge',
}

export enum AutopilotActionSourceType {
  post = 'post',
  draft = 'draft',
}
